angular.module('mm.foundation.templates', ['template/accordion/accordion-group.html', 'template/accordion/accordion.html', 'template/modal/backdrop.html', 'template/modal/window.html']);

angular.module("template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/accordion/accordion-group.html",
    "<div class=\"accordion-element\" data-ng-attr-data-expanded=\"{{isOpen}}\"><div role=\"button\" tabindex=\"0\" class=\"accordion-button\" data-ng-attr-aria-expanded=\"{{isOpen}}\" data-ng-class=\"{'active': isOpen}\" data-ng-click=\"isOpen = !isOpen\"><span class=\"accordion-headline\" data-accordion-transclude=\"heading\">{{heading}}</span> <img src=\"../iplusjs/assets/img/arrow_down.svg\" alt=\"\" aria-hidden=\"true\" role=\"presentation\"></div><div class=\"accordion-content\" role=\"tabpanel\" data-ng-class=\"{'active': isOpen}\" data-ng-show=\"isOpen\" data-ng-transclude></div></div>");
}]);

angular.module("template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/accordion/accordion.html",
    "<div role=\"tablist\" ng-transclude></div>");
}]);

angular.module("template/modal/backdrop.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/modal/backdrop.html",
    "<div class=\"reveal-modal-bg fade\" ng-class=\"{in: animate}\" ng-click=\"close($event)\" style=\"display:block\"></div>");
}]);

angular.module("template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/modal/window.html",
    "<div tabindex=\"-1\" class=\"reveal-modal fade {{ windowClass }}\" ng-class=\"{in: animate}\" style=\"display:block;visibility:visible\"><div ng-transclude></div></div>");
}]);
